<template>
  <div id="content" class="fixed h-full w-full flex">
    <LeftPanel />
    <Map />
    <!-- <MapContainer /> -->
  </div>
</template>

<script>
import LeftPanel from './LeftPanel.vue';
import Map from './Map.vue';

export default {
  name: 'Content',
  components: {
    LeftPanel,
    Map,
  },
};
</script>

<style lang="stylus">
  #content
    max-height calc(100% - 48px)
</style>
